import { TYPES } from "./types";
import { tkt1ImageAlbumService } from "../services"; 

export const getTKT1ImageAlbums = (query) => async (dispatch) => {
  try {
    const result = await tkt1ImageAlbumService.getImageAlbums(query);
    const data = result.data;
    
    if (data && data.data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_IMAGE_ALBUMS_SUCCESS,
        payload: {data: data.data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_IMAGE_ALBUMS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1ImageAlbumByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1ImageAlbumService.getImageAlbumById(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_IMAGE_ALBUM_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_IMAGE_ALBUM_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1ImageAlbumByMID = (mid) => async (dispatch) => {
  try {
    const result = await tkt1ImageAlbumService.getImageAlbumByMID(mid);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_IMAGE_ALBUM_BY_MID_SUCCESS,
        payload: {data},
      });
      return result; // Return the response data
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_IMAGE_ALBUM_BY_MID_FAIL,
        payload: {},
      });
      return null;
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
    throw error; // Re-throw the error
  }
};

export const createTKT1ImageAlbum = (albumData) => async (dispatch) => {
  try {
    const result = await tkt1ImageAlbumService.createImageAlbum(albumData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_IMAGE_ALBUM_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_IMAGE_ALBUM_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1ImageAlbum = (id, albumData) => async (dispatch) => {
  try {
    const result = await tkt1ImageAlbumService.updateImageAlbum(id, albumData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_IMAGE_ALBUM_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_IMAGE_ALBUM_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1ImageAlbum = (id) => async (dispatch) => {
  try {
    const result = await tkt1ImageAlbumService.deleteImageAlbum(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_IMAGE_ALBUM_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_IMAGE_ALBUM_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1ImageAlbumAction = {
  getTKT1ImageAlbums,
  getTKT1ImageAlbumByID,
  getTKT1ImageAlbumByMID,
  createTKT1ImageAlbum,
  updateTKT1ImageAlbum,
  deleteTKT1ImageAlbum
};
